<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import QrReader from '@/vcs/_shared/QrReader.vue'
import { XIcon } from 'vue-feather-icons'

export default {
  extends: BaseModal,
  components: { QrReader, XIcon },
  methods: {
    onDecode(event) {
      this.close(event)
    },
  },
}
</script>

<template lang="pug">
span
  .modal-body.modal-body--fixed
    qr-reader(@onDecode="onDecode")
  .modal-caption {{ $t('qrModal.caption') }}
  .modal-fixed-controls(@click="close(false)")
    x-icon(size="1.5x")
</template>

<style lang="scss" scoped>
@import '@/assets/styles/mixins.scss';
.modal-body {
  background: black;
}
.modal-caption {
  width: 100vw;
  padding: 25px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  font-size: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
}
</style>
